import add_installation_dialog from './add_installation_dialog.js';
import control_panel_dialog from './control_panel.js';
import add_virtual_machine_dialog from './internal/add_virtual_machine_dialog.js';
import add_site_dialog from './internal/add_site_dialog.js';
import add_product_dialog from './internal/add_product_dialog.js';
import add_product_version_dialog from './internal/add_product_version_dialog.js';
import add_extra_script_dialog from './internal/add_extra_script_dialog.js';
import add_product_feature_dialog from './internal/add_product_feature_dialog.js';
import confirm_account_dialog from './internal/confirm_account_dialog.js';

export default [
	add_installation_dialog,
	control_panel_dialog,
	add_virtual_machine_dialog,
	add_site_dialog,
	add_product_dialog,
	add_product_version_dialog,
	add_extra_script_dialog,
	add_product_feature_dialog,
	confirm_account_dialog
];
